import React from 'react';
import { useTranslation } from 'react-i18next';
import type { FormRule } from 'antd';
import { Form, Input } from 'antd';
import type { IContactFormFields, IContactFormProps } from './types';

const validationRule: Record<keyof IContactFormFields, FormRule[]> = {
  name: [{ required: true, type: 'string', min: 3 }],
  phone: [{ required: true, type: 'string', min: 3 }],
  email: [{ required: true, type: 'email' }],
  role: [{ required: false, type: 'string' }],
};

export const ContactForm: React.FC<IContactFormProps> = (props) => {
  const { form, formId, initialValues, onFinish } = props;
  const { t } = useTranslation('contact');

  return (
    <Form form={form} id={formId} layout='vertical' initialValues={initialValues} onFinish={onFinish}>
      <Form.Item name='name' label={t('form_name')} rules={validationRule.name}>
        <Input placeholder={t('form_name')} />
      </Form.Item>
      <Form.Item name='phone' label={t('common:phone')} rules={validationRule.phone}>
        <Input placeholder={t('common:phone')} />
      </Form.Item>
      <Form.Item name='email' label={t('common:email')} rules={validationRule.email}>
        <Input placeholder={t('common:email')} />
      </Form.Item>
      <Form.Item name='role' label={t('form_role')} rules={validationRule.role}>
        <Input placeholder={t('form_role')} />
      </Form.Item>
    </Form>
  );
};
